import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_FOREST } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/adventure.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/adventure-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/adventure-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/adventure-extreme.circles.json' with { type: 'json' };

export const ADVENTURE_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'adventure',
  baseTitle: "Adventure",
  description: "JJD's melodic glitch hop. Soft mid-tier cube run with a strong melodic hook.",
  difficulty: 2,
  palette: PALETTE_FOREST,
  attribution: "\"Adventure\" by JJD [NCS Release] - https://ncs.io/Adventure",
  mapper: "GGPLAYS_YT",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 110, offsetMs: 14052.6, totalBeats: 87 },
    hard: { bpm: 101, offsetMs: 0, totalBeats: 104 },
    extreme: { bpm: 160, offsetMs: 0, totalBeats: 163 },
  },
});
